import GenericService from './genericService';
import axiosInstance from '../utils/axios';
import axios from 'axios';
import { getTokens } from '../utils/tokenUtils';

class JobOrderLpoService extends GenericService {
    constructor() {
        super('/job_order_lpos', axiosInstance);
    }

    // Create new item with file
    async createWithFile(data) {
        try {
            const response = await axiosInstance.post(this.baseUrl, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getFGItems(jobOrderId) {
        try {
            const encodedJobOrderId = this.encodePathSegment(jobOrderId);
            const response = await axiosInstance.get(`${this.baseUrl}/${encodedJobOrderId}/fg_items`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getJobCostings(jobOrderId) {
        try {
            const encodedJobOrderId = this.encodePathSegment(jobOrderId);
            const response = await axiosInstance.get(`${this.baseUrl}/${encodedJobOrderId}/job_costings`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getOrdersByLpo(lpoNumber) {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/lpo`, {
                params: { number: lpoNumber }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async searchCostedLpos(lpoNumber) {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/search/costed`, {
                params: { number: lpoNumber }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async searchDeliveredLpos(lpoNumber) {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/search/delivered`, {
                params: { number: lpoNumber }
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }


    async uploadLpoPdf(formData) {
        try {
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            
            // Create a new FormData to ensure it's fresh
            const freshFormData = new FormData();
            for (let [key, value] of formData.entries()) {
                freshFormData.append(key, value);
            }
            
            console.log('Service: Fresh FormData entries:');
            for (let [key, value] of freshFormData.entries()) {
                console.log(key, value);
            }
            
            // Use native fetch API for file uploads to avoid axios Content-Type issues
            const tokens = getTokens();
            const headers = {
                'Accept': 'application/json'
                // Don't set Content-Type - let browser set it automatically
            };
            
            if (tokens && tokens.accessToken) {
                headers.Authorization = `Bearer ${tokens.accessToken}`;
            }
            
            console.log('Uploading with fetch API');
            console.log('FormData entries:');
            for (let [key, value] of freshFormData.entries()) {
                console.log(key, value);
            }
            
            const response = await fetch('/api/job_order_lpos/upload/pdf', {
                method: 'POST',
                headers: headers,
                body: freshFormData
            });
            
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Upload failed');
            }
            
            return await response.json();
        } catch (error) {
            console.error('Service: Upload error:', error);
            throw this.handleError(error);
        }
    }

    async getFileUrl(filePath) {
        try {
            const encodedFilePath = this.encodePathSegment(filePath);
            const response = await axiosInstance.get(`${this.baseUrl}/file/${encodedFilePath}`, {
                responseType: 'blob' // Important: get the file as blob
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async reverse(id) {
        try {
            const response = await axiosInstance.post(`${this.baseUrl}/${this.encodePathSegment(id)}/reverse`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }
}

export default new JobOrderLpoService(); 